// extracted by mini-css-extract-plugin
module.exports = {"date-col":"styles_date-col__23HYD","dateCol":"styles_date-col__23HYD"};